var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kbutton',{attrs:{"icon":'pencil',"theme-color":'primary',"fill-mode":'outline',"size":'small'},on:{"click":_vm.editHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }